// Module
var code = "<multiple-select collection=\"eventAppearanceOptions\" full-options-width=\"true\" full-width=\"true\" ng-change=\"onEventAppearanceChange()\" ng-disabled=\"!attendanceFeatureAvailable\" ng-model=\"eventAppearance\" placeholder=\"Select\" variant=\"v2\"></multiple-select>\n";
// Exports
module.exports = code;